import { render } from "./StructureUnitData.vue?vue&type=template&id=7e58f6f4"
import script from "./StructureUnitData.vue?vue&type=script&lang=js"
export * from "./StructureUnitData.vue?vue&type=script&lang=js"

import "./StructureUnitData.vue?vue&type=style&index=0&id=7e58f6f4&lang=css"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__